import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';

const LeaveTypeForm = (props) => {
    const [state, setState] = useState({
        leaveTypeName: { name: 'leaveTypeName', value: props.data?.LEAVE_TYPE_NAME || '', isRequired: true, error: '' },
        leaveCode: { name: 'leaveCode', value: props.data?.LEAVE_CODE || '', isRequired: true, error: '' },
        description: { name: 'description', value: props.data?.DESCRIPTION || '', isRequired: false, error: '' },
        numberOfDays: { name: 'numberOfDays', value: props.data?.NUMBER_OF_DAYS || 0, isRequired: true, error: '' },
        isCarryForward: { name: 'isCarryForward', value: props.data?.IS_CARRY_FORWARD || false, isRequired: false },
        isEncashable: { name: 'isEncashable', value: props.data?.IS_ENCASHABLE || false, isRequired: false },
        genderSpecific: { name: 'genderSpecific', value: props.data?.GENDER_SPECIFIC || 'All', isRequired: false },
        isActive: { name: 'isActive', value: props.data?.IS_ACTIVE || true, isRequired: false },
        leaveCycleType: { name: 'leaveCycleType', value: props.data?.LEAVE_CYCLE_TYPE || 'Calendar Year', isRequired: true, error: '' },
        isPaid: { name: 'isPaid', value: props.data?.IS_PAID || true, isRequired: false },
        requiresApproval: { name: 'requiresApproval', value: props.data?.REQUIRES_APPROVAL || true, isRequired: false },
        maxApplicationsPerMonth: { name: 'maxApplicationsPerMonth', value: props.data?.MAX_APPLICATIONS_PER_MONTH || '', isRequired: false },
        attachmentRequired: { name: 'attachmentRequired', value: props.data?.ATTACHMENT_REQUIRED || false, isRequired: false },
    });

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                leaveTypeName: state.leaveTypeName.value,
                leaveCode: state.leaveCode.value,
                description: state.description.value,
                numberOfDays: state.numberOfDays.value,
                isCarryForward: state.isCarryForward.value,
                isEncashable: state.isEncashable.value,
                genderSpecific: state.genderSpecific.value,
                isActive: state.isActive.value,
                leaveCycleType: state.leaveCycleType.value,
                isPaid: state.isPaid.value,
                requiresApproval: state.requiresApproval.value,
                maxApplicationsPerMonth: state.maxApplicationsPerMonth.value,
                attachmentRequired: state.attachmentRequired.value,
            };
            if (props.data) {
                model.id = props.data.ID
            }
            props.onSubmit(model);
        }
    };

    return (
        <form onSubmit={onSubmit}>
            <h4 className="card-title mb-4">{props.title}</h4>
            <div className="row">
                {[
                    { label: 'Leave Type Name', name: 'leaveTypeName', placeholder: 'Enter leave type name' },
                    { label: 'Leave Code', name: 'leaveCode', placeholder: 'Enter unique leave code' },
                    { label: 'Number of Days', name: 'numberOfDays', type: 'number', placeholder: 'e.g. 10' },
                    { label: 'Max Applications / Month', name: 'maxApplicationsPerMonth', type: 'number', placeholder: 'e.g. 2' }
                ].map(({ label, name, type = 'text', placeholder }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
                        <input
                            type={type}
                            name={state[name].name}
                            value={state[name].value}
                            onChange={onChange}
                            placeholder={placeholder}
                            className={state[name].error ? "form-control is-invalid" : "form-control"}
                        />
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        name={state.description.name}
                        value={state.description.value}
                        onChange={onChange}
                        placeholder="Enter leave type description (optional)"
                        className="form-control"
                        rows={3}
                    />
                </div>

                {[
                    { label: 'Gender Specific', name: 'genderSpecific', options: ['All', 'Male', 'Female'] },
                    { label: 'Leave Cycle Type', name: 'leaveCycleType', options: ['Calendar Year', 'Financial Year', 'Joining Anniversary'] }
                ].map(({ label, name, options }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
                        <select
                            name={state[name].name}
                            value={state[name].value}
                            onChange={onChange}
                            className="form-select"
                        >
                            {options.map((opt) => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                ))}
                <div className='row ms-2'>
                    {[
                        { label: 'Carry Forward', name: 'isCarryForward' },
                        { label: 'Encashable', name: 'isEncashable' },
                        { label: 'Active', name: 'isActive' },
                        { label: 'Paid Leave', name: 'isPaid' },
                        { label: 'Requires Approval', name: 'requiresApproval' },
                        { label: 'Attachment Required', name: 'attachmentRequired' }
                    ].map(({ label, name }) => (
                        <div className="col-md-4 mb-3 form-check" key={name}>
                            <input
                                type="checkbox"
                                name={state[name].name}
                                checked={state[name].value}
                                onChange={onChange}
                                className="form-check-input"
                                id={name}
                            />
                            <label className="form-check-label" htmlFor={name}>{label}</label>
                        </div>
                    ))}
                </div>

            </div>
            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <button type="reset" className="btn btn-danger"
                                        onClick={() => window.history.back()}
                
                >Cancel</button>
            </div>
        </form>
    );
};

export default LeaveTypeForm;
